import React, { useCallback, useContext } from 'react';
import { ComponentPropsWithRef, FunctionComponent } from 'react';
import { CalendarContext } from '../../contexts/CalendarContext';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { useActiveMonth } from '../../hooks';

export type CalendarPreviousButtonProps = {} & Omit<ComponentPropsWithRef<'button'>, 'onClick'>;

export const CalendarPreviousButton: FunctionComponent<CalendarPreviousButtonProps> = ({
    children,
    className,
    ...buttonProps
}) => {
    const { setActiveDate } = useContext(CalendarContext);
    const previousMonth = useActiveMonth(-1);

    const onClick = useCallback(() => {
        setActiveDate(previousMonth.range.from);
    }, [setActiveDate, previousMonth]);

    return (
        <button
            {...buttonProps}
            className={classNames(styles.nextButton, className)}
            onClick={onClick}
        >
            {children || '←'}
        </button>
    );
};
